

import { defineStore } from 'pinia'
import { getDomainInfo } from '@/api/index'
import { initFacebookPixel, isFacebookPixelInitialized } from '@/utils/facebook-pixel'
import { AdjustTracking, AppsFlyerTracking } from '@/utils/event-tracking'
import { setFirebaseConfig, setFirebaseEnvConfig } from '@/config/firebase'
// 移除不再需要的Firebase服务导入
import { saveFirebaseConfig } from '@/utils/firebase-config-db'
import { useFirebasePushInApp } from '@/utils/firebase-push-service'
const {
    initializeFirebasePush
} = useFirebasePushInApp();
export const useAppStore = defineStore('app', {
    state: () => ({
        domainInfo: {
            domainRedirect: null,
            domainType: null,// 1 主域名 2 推广域名
        },
        channelInfo: null,
        pixelId: null,
        adjustTrackingConfig: {
            appToken: "",
            s2s_token: "",
            login: "",
            completeRegistration: "",
            recharge: "",
            purchase: "",
            enterGame: "",
            logout: "",
            registerClick: "",
            rechargeClick: "",
            pageView: "",
            install: "",
            firstOpen: ""
        },
        appsFlyerDevKey: null,
        downloadOpen: 0,
        isSocketConnected: false,// 是否连接socket
    }),
    getters: {},

    actions: {
        async getDomainInfo() {
            // 从 URL 查询参数中获取 channelId，从当前访问域名获取 domain
            const searchParams = new URLSearchParams(window.location.search)
            const channelId = searchParams.get('channelId') || ''
            const from = searchParams.get('huiohuhhuhiuhh') || ''//from容易覆盖所以改成huiohuhhuhiuhh跳转前域名
            
            // 获取缓存中的from值
            const cachedFrom = localStorage.getItem('domain_from') || ''
            
            let d = ''
            if (from) {
                // 如果URL中有from参数且有值，使用from的值并更新缓存
                d = from
                localStorage.setItem('domain_from', from)
            } else if (cachedFrom) {
                // 如果URL中没有from但缓存中有，使用缓存的值
                d = cachedFrom
            } else {
                // 如果URL和缓存都没有，使用当前域名
                d = window.location.hostname
            }

            const res = await getDomainInfo({ params: { channelId, domain: d } })
            if (res.code !== 0) {
                return
            }
            const { channelInfo, domain } = res.data
            if (domain) {
                this.domainInfo.domainRedirect = domain.landing // 落地页指向
                this.domainInfo.domainType = domain.type // 域名类型
            }
            // 判断是什么埋点类型
            if (channelInfo) {
                this.channelInfo = channelInfo
                this.downloadOpen = channelInfo.downloadOpen
                if (channelInfo.trackType === 2) {
                    this.pixelId = channelInfo.trackConfig?.facebook?.pixel_id
                    // 处理 pixelId 并初始化 Facebook Pixel
                    const platformPixelId = (() => {
                        try {
                            return window.platformGame?.getPixelId?.()
                        } catch {
                            return undefined
                        }
                    })()
                    const incomingPixelId = this.pixelId || platformPixelId
                    if (incomingPixelId && !isFacebookPixelInitialized()) {
                        const ok = await initFacebookPixel(String(incomingPixelId), { autoPageView: false })
                        if (ok) this.pixelId = String(incomingPixelId)
                    }
                }
                if (channelInfo.trackType === 3) {
                    // 这里接入adjust
                    this.adjustTrackingConfig = channelInfo.trackConfig?.adjust
                    if (this.adjustTrackingConfig.appToken) {
                        // 初始化 Adjust
                        try {
                            const adjustTracking = await AdjustTracking.initAdjust(
                                this.adjustTrackingConfig.appToken,
                                import.meta.env.VITE_DEV === 'true'
                            )
                            // 将实例添加到全局
                            if (typeof window !== 'undefined') {
                                window.$adjustTracking = adjustTracking
                                adjustTracking.trackFirstOpen()
                            }
                            console.log('[Adjust] Initialized successfully with appToken:', this.adjustTrackingConfig.appToken)
                        } catch (error) {
                            console.error('[Adjust] Failed to initialize:', error)
                        }
                    }
                }
                if (channelInfo.trackType === 4) {
                    // 这里接入AppsFlyer
                    this.appsFlyerDevKey = channelInfo.trackConfig?.appsflyer?.devKey
                    // 初始化 AppsFlyer
                    try {
                        const appsFlyerTracking = await AppsFlyerTracking.initAppsFlyer(
                            this.appsFlyerDevKey,
                            import.meta.env.VITE_DEV === 'true'
                        )
                        // 将实例添加到全局
                        if (typeof window !== 'undefined') {
                            window.$appsFlyerTracking = appsFlyerTracking
                        }
                        console.log('[AppsFlyer] Initialized successfully with devKey:', this.appsFlyerDevKey)
                    } catch (error) {
                        console.error('[AppsFlyer] Failed to initialize:', error)
                    }
                }
            }
        },
        updateSocketConnected(value: boolean) {
            this.isSocketConnected = value
        }
    },
}) 